import React from 'react';
import { Modal } from '@amzn/awsui-components-react';
import CsqaForm from '../form/Form';
import { GetCsqaPayload } from '../types';
import { UserRole } from '../../../common/EmployeeContext';

interface EditReviewModalProps {
    visible: boolean;
    onDismiss: () => void;
    selectedReview: GetCsqaPayload;
    org: string;
    role?: UserRole;
    user: string;
    userPermissions: Set<string>;
    onSubmit: (updatedData: Partial<GetCsqaPayload>) => void;
}

const EditReviewModal: React.FC<EditReviewModalProps> = ({
    visible,
    onDismiss,
    selectedReview,
    org,
    role,
    user,
    userPermissions,
    onSubmit
}) => {
    return (
        <Modal
            visible={visible}
            size='max'
            onDismiss={onDismiss}
            header='Edit CSQA Review Details'
            footer={null}
        >
            <CsqaForm
                user={user}
                role={role}
                userPermissions={userPermissions}
                org={org}
                initialData={selectedReview}
                onSubmit={onSubmit}
                isEditing={true}
            />
        </Modal>
    );
};

export default EditReviewModal;
